import * as React from 'react'
import { useState } from 'react'
import { Box, FormControl, Select, MenuItem } from '@mui/material'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

interface DisplayItemCalcSettingsProps {
    kedo: any
    item: any
    onChange: any
    disabled: boolean
}

const DisplayItemCalcSettings: React.FC<DisplayItemCalcSettingsProps> = ({
    kedo,
    item,
    onChange,
    disabled,
}) => {
    const [output, setOutput] = useState(
        item && item.settings && item.settings.output
            ? item.settings.output
            : null
    )

    return (
        <Box>
            <FormControl fullWidth margin="dense">
                <FormInputLabel>{kedo.t('Output')}</FormInputLabel>

                <Select
                    size="small"
                    name={'output'}
                    onChange={(e) => {
                        setOutput(e.target.value)
                        onChange('output', e.target.value)
                    }}
                    value={output}
                    displayEmpty
                    disabled={disabled}
                >
                    <MenuItem value={''}>{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value={'DATE'}>{kedo.t('Date')}</MenuItem>
                    <MenuItem value={'DATETIME'}>{kedo.t('Datetime')}</MenuItem>
                    <MenuItem value={'INTEGER'}>{kedo.t('Integer')}</MenuItem>
                    <MenuItem value={'DECIMAL'}>{kedo.t('Decimal')}</MenuItem>
                </Select>
            </FormControl>
        </Box>
    )
}

export default DisplayItemCalcSettings
